module.exports = __webpack_public_path__ + "static/media/close.6b1e036b.svg";